import styled, { css } from 'styled-components'
import { themeContract } from './CountBadge.theme.contract'

const Badge = styled.span`
  border-radius: 50%;
  color: #fff;
  text-align: center;
  font-size: 14px;
  line-height: 22px;

  ${props =>
    props.type &&
    css`
      background-color: ${props.theme.color.palette[themeContract[props.theme.channel].badge.background]};
    `}

  ${props =>
    props.isFlag &&
    css`
      display: block;
      cursor: pointer;
      margin-right: 8px;
      float: left;
      height: 22px;
      width: 22px;
      margin-top: 2px;
    `}

    ${props =>
      !props.isFlag &&
      css`
        flex-shrink: 0;
        height: 24px;
        width: 24px;
        line-height: 24px;
        margin-left: 10px;
      `}

`
export { Badge } //eslint-disable-line
